module.exports = __webpack_public_path__ + "static/media/emma_poster.4ffd8e52.gif";